import type { SVGProps } from 'react';
const DawnFlagPY = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-PY_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-PY_svg__a)">
      <path fill="#E33F39" fillRule="evenodd" d="M0 5.333h22V0H0z" clipRule="evenodd" />
      <path fill="#124BBA" fillRule="evenodd" d="M0 16h22v-5.333H0z" clipRule="evenodd" />
      <path
        stroke="#398153"
        strokeWidth={0.667}
        d="M11 9.933c1.058 0 1.905-.871 1.905-1.933S12.058 6.067 11 6.067c-1.057 0-1.905.87-1.905 1.933 0 1.062.848 1.933 1.905 1.933Z"
      />
      <path
        fill="#E5CF58"
        fillRule="evenodd"
        d="M11 8.533c.29 0 .524-.239.524-.533A.53.53 0 0 0 11 7.467a.53.53 0 0 0-.523.533c0 .294.234.533.523.533"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagPY;
